<ng-template #modalTemplate>
  <div [attr.role]="fullScreen() ? 'dialog' : null"
       [attr.aria-modal]="fullScreen() ? 'true' : null"
       [attr.aria-labelledby]="showHeader() ? titleId : null"
       class="td-wb-bottom-modal__container"
       [class.td-wb-bottom-modal--full-screen]="fullScreen()"
       [class.td-wb-bottom-modal--no-padding]="noPadding()"
       animate.enter="td-wb-bottom-modal--enter"
       animate.leave="td-wb-bottom-modal--leave">
    @if (showHeader()) {
      <div class="td-wb-bottom-modal__header">
        <h2 [attr.id]="titleId"
            class="td-wb-bottom-modal__header-text"
            [class.td-wb-bottom-modal__header-text--center]="centerHeader()">
          <ng-content select=".td-wb-bottom-modal__header-title" />
        </h2>
        <button class="td-wb-bottom-modal__header-close-button"
                id="bottomModalCloseButton"
                tdWbIconButton
                tdWbIconButtonShape="circle"
                tdWbIconButtonSize="extra-small"
                [attr.aria-label]="'tdWb.help.CLOSE' | tdWbTranslate"
                (click)="close()">
          <td-wb-icon iconId="close--small"
                      size="12" />
        </button>
      </div>
    }
    <div class="td-wb-bottom-modal__body">
      <ng-content />
    </div>
  </div>
</ng-template>


